export const inputStyles = {
  wrapper:
    "box-border flex items-center rounded-xl w-full px-4 py-3 sm:py-4 pos-r ease-in-out duration-200 rounded-[10px]",
  label:
    "absolute text-base pl-0.5 font-i ease-in-out duration-150 text-gray600 cursor-text origin-top-left",
  input:
    "text-base leading-normal py-0 outline-0 border-0 w-full pos-r bg-transparent placeholder:text-gray400 text-gray800",
} as const;
